import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/img/home.svg'
import _imports_1 from '@/img/home_green.svg'
import _imports_2 from '@/img/cards.svg'
import _imports_3 from '@/img/cards_active.svg'
import _imports_4 from '@/img/megaphone.svg'
import _imports_5 from '@/img/megaphone_green.svg'
import _imports_6 from '@/img/chat.svg'
import _imports_7 from '@/img/chat_green.svg'
import _imports_8 from '@/img/users.svg'
import _imports_9 from '@/img/users_green.svg'
import _imports_10 from '@/img/videoCorsi.svg'
import _imports_11 from '@/img/videoCorsi_green.svg'
import _imports_12 from '@/img/assistenza.svg'
import _imports_13 from '@/img/assistenza_green.svg'
import _imports_14 from '@/img/clipboard.svg'
import _imports_15 from '@/img/clipboard_green.svg'
import _imports_16 from '@/img/cart.svg'
import _imports_17 from '@/img/cart_green.svg'
import _imports_18 from '@/img/shopping_bag.svg'
import _imports_19 from '@/img/shopping_bag_green.svg'
import _imports_20 from '@/img/questionario.svg'
import _imports_21 from '@/img/questionario_green.svg'
import _imports_22 from '@/img/faq.svg'
import _imports_23 from '@/img/faq_green.svg'
import _imports_24 from '@/img/recipes.svg'
import _imports_25 from '@/img/recipes_green.svg'
import _imports_26 from '@/img/progress.svg'
import _imports_27 from '@/img/progress_green.svg'
import _imports_28 from '@/img/profilo.svg'
import _imports_29 from '@/img/profilo_green.svg'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "off"
}, null, -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "on"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "off"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "on"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "off"
}, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_5,
  class: "on"
}, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_6,
  class: "off"
}, null, -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_7,
  class: "on"
}, null, -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_8,
  class: "off"
}, null, -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_9,
  class: "on"
}, null, -1)
const _hoisted_11 = ["src"]
const _hoisted_12 = ["src"]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_10,
  class: "off"
}, null, -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_11,
  class: "on"
}, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_12,
  class: "off"
}, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_13,
  class: "on"
}, null, -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_14,
  class: "off"
}, null, -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_15,
  class: "on"
}, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_16,
  class: "off"
}, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_17,
  class: "on"
}, null, -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_18,
  class: "off"
}, null, -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_19,
  class: "on"
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_20,
  class: "off"
}, null, -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_21,
  class: "on"
}, null, -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_22,
  class: "off"
}, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_23,
  class: "on"
}, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_24,
  class: "off"
}, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_25,
  class: "on"
}, null, -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_26,
  class: "off"
}, null, -1)
const _hoisted_30 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_27,
  class: "on"
}, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_28,
  class: "off"
}, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_29,
  class: "on"
}, null, -1)
const _hoisted_33 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_localized_text = _resolveComponent("localized-text")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_ctx.moduleConfig.name == 'Home')
    ? (_openBlock(), _createBlock(_component_router_link, {
        key: 0,
        to: "/home",
        class: "nav"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, [
            _createVNode(_component_localized_text, {
              localizedKey: "Home",
              text: "Home"
            })
          ]),
          _hoisted_1,
          _hoisted_2
        ]),
        _: 1
      }))
    : (_ctx.moduleConfig.name == 'Cards')
      ? (_openBlock(), _createBlock(_component_router_link, {
          key: 1,
          to: "/cards",
          class: "nav"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(_component_localized_text, {
                localizedKey: "Carte",
                text: "Carte"
              })
            ]),
            _hoisted_3,
            _hoisted_4
          ]),
          _: 1
        }))
      : (_ctx.moduleConfig.name == 'News')
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 2,
            to: "/newsFeed",
            class: "nav"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, [
                _createVNode(_component_localized_text, {
                  localizedKey: "News",
                  text: "News"
                })
              ]),
              _hoisted_5,
              _hoisted_6
            ]),
            _: 1
          }))
        : (_ctx.moduleConfig.name == 'Chat')
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 3,
              to: "/chat",
              class: "nav"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  _createVNode(_component_localized_text, {
                    localizedKey: "Chat",
                    text: "Chat"
                  })
                ]),
                _hoisted_7,
                _hoisted_8
              ]),
              _: 1
            }))
          : (_ctx.moduleConfig.name == 'Clienti')
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 4,
                to: "/clienti",
                class: "nav"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createVNode(_component_localized_text, {
                      localizedKey: "Clienti",
                      text: "Clienti"
                    })
                  ]),
                  _hoisted_9,
                  _hoisted_10
                ]),
                _: 1
              }))
            : (_ctx.moduleConfig.name == 'Piano alimentare')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 5,
                  to: "/pianoAlimentare",
                  class: "nav"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createVNode(_component_localized_text, {
                        localizedKey: "Piano alimentare",
                        text: "Piano alimentare"
                      })
                    ]),
                    _createElementVNode("img", {
                      src: _ctx.$store.state.consts.projectConfig.logoUrl,
                      class: "off"
                    }, null, 8, _hoisted_11),
                    _createElementVNode("img", {
                      src: _ctx.$store.state.consts.projectConfig.logoUrl,
                      class: "on"
                    }, null, 8, _hoisted_12)
                  ]),
                  _: 1
                }))
              : (_ctx.moduleConfig.name == 'Corsi')
                ? (_openBlock(), _createBlock(_component_router_link, {
                    key: 6,
                    to: "/corsi",
                    class: "nav"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", null, [
                        _createVNode(_component_localized_text, {
                          localizedKey: "Corsi",
                          text: "Corsi"
                        })
                      ]),
                      _hoisted_13,
                      _hoisted_14
                    ]),
                    _: 1
                  }))
                : (_ctx.moduleConfig.name == 'Assistenza')
                  ? (_openBlock(), _createBlock(_component_router_link, {
                      key: 7,
                      to: "/assistenza",
                      class: "nav"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", null, [
                          _createVNode(_component_localized_text, {
                            localizedKey: "Assistenza",
                            text: "Assistenza"
                          })
                        ]),
                        _hoisted_15,
                        _hoisted_16
                      ]),
                      _: 1
                    }))
                  : (_ctx.moduleConfig.name == 'Prenotazioni')
                    ? (_openBlock(), _createBlock(_component_router_link, {
                        key: 8,
                        to: "/prenotazioni",
                        class: "nav"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_localized_text, {
                              localizedKey: "Prenotazioni",
                              text: "Prenotazioni"
                            })
                          ]),
                          _hoisted_17,
                          _hoisted_18
                        ]),
                        _: 1
                      }))
                    : (_ctx.moduleConfig.name == 'Negozio')
                      ? (_openBlock(), _createBlock(_component_router_link, {
                          key: 9,
                          to: "/shop",
                          class: "nav"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", null, [
                              _createVNode(_component_localized_text, {
                                localizedKey: "Negozio",
                                text: "Negozio"
                              })
                            ]),
                            _hoisted_19,
                            _hoisted_20
                          ]),
                          _: 1
                        }))
                      : (_ctx.moduleConfig.name == 'Acquisti')
                        ? (_openBlock(), _createBlock(_component_router_link, {
                            key: 10,
                            to: "/acquisti",
                            class: "nav"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", null, [
                                _createVNode(_component_localized_text, {
                                  localizedKey: "Acquisti",
                                  text: "Acquisti"
                                })
                              ]),
                              _hoisted_21,
                              _hoisted_22
                            ]),
                            _: 1
                          }))
                        : (_ctx.moduleConfig.name == 'Questionari')
                          ? (_openBlock(), _createBlock(_component_router_link, {
                              key: 11,
                              to: "/questionari",
                              class: "nav"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_localized_text, {
                                    localizedKey: "Questionari",
                                    text: "Questionari"
                                  })
                                ]),
                                _hoisted_23,
                                _hoisted_24
                              ]),
                              _: 1
                            }))
                          : (_ctx.moduleConfig.name == 'Faq')
                            ? (_openBlock(), _createBlock(_component_router_link, {
                                key: 12,
                                to: "/faq/0",
                                class: "nav"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", null, [
                                    _createVNode(_component_localized_text, {
                                      localizedKey: "FAQ",
                                      text: "FAQ"
                                    })
                                  ]),
                                  _hoisted_25,
                                  _hoisted_26
                                ]),
                                _: 1
                              }))
                            : (_ctx.moduleConfig.name == 'Ricettario')
                              ? (_openBlock(), _createBlock(_component_router_link, {
                                  key: 13,
                                  to: "/ricettario/0",
                                  class: "nav"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("div", null, [
                                      _createVNode(_component_localized_text, {
                                        localizedKey: "Ricettario",
                                        text: "Ricettario"
                                      })
                                    ]),
                                    _hoisted_27,
                                    _hoisted_28
                                  ]),
                                  _: 1
                                }))
                              : (_ctx.moduleConfig.name == 'Storico')
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 14,
                                    to: "/storico",
                                    class: "nav"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", null, [
                                        _createVNode(_component_localized_text, {
                                          localizedKey: "Storico",
                                          text: "Storico"
                                        })
                                      ]),
                                      _hoisted_29,
                                      _hoisted_30
                                    ]),
                                    _: 1
                                  }))
                                : (_ctx.moduleConfig.name == 'Profilo')
                                  ? (_openBlock(), _createBlock(_component_router_link, {
                                      key: 15,
                                      to: "/profile",
                                      class: "nav"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_localized_text, {
                                            localizedKey: "Profilo",
                                            text: "Profilo"
                                          })
                                        ]),
                                        _hoisted_31,
                                        _hoisted_32
                                      ]),
                                      _: 1
                                    }))
                                  : (_ctx.moduleConfig.isCustom)
                                    ? (_openBlock(), _createElementBlock("a", {
                                        key: 16,
                                        href: _ctx.moduleConfig.customUrl,
                                        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.$store.state.openBrowser && _ctx.$store.state.openBrowser(...args))),
                                        class: "nav"
                                      }, [
                                        _createElementVNode("div", null, [
                                          _createVNode(_component_localized_text, {
                                            localizedKey: _ctx.moduleConfig.customName,
                                            text: _ctx.moduleConfig.customName
                                          }, null, 8, ["localizedKey", "text"])
                                        ])
                                      ], 8, _hoisted_33))
                                    : _createCommentVNode("", true)
}